export default "__VITE_ASSET__53e3b945__"